import React from 'react';
import kebabCase from 'lodash/kebabCase';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import { ButtonWithIcon } from '@els/els-react--button';

function ConditionsButton({ conditionsIsShown, setConditionsIsShown, routeType }) {
  const onClickHandler = () => {
    setConditionsIsShown(!conditionsIsShown);
  };

  let label;
  switch (routeType) {
    case RouteType.PREDICTED:
      label = 'Reaxys Examples';
      break;
    case RouteType.COMBINED:
      label = 'conditions/examples';
      break;
    default:
      label = 'conditions';
  }

  const buttonProps = conditionsIsShown
    ? {
        sprite: 'EyeNotVisible',
        className: `e2e-rs-toolbar-button-hide-${kebabCase(label)}`,
        children: `Hide ${label}`,
      }
    : {
        sprite: 'EyeVisible',
        className: `e2e-rs-toolbar-button-show-${kebabCase(label)}`,
        children: `Show ${label}`,
      };

  return (
    <ButtonWithIcon
      data-e2e="show-hide-conditions-examples"
      layout="vertical"
      type="borderless"
      size="small"
      onClick={onClickHandler}
      {...buttonProps}
    />
  );
}

export default ConditionsButton;
